import { z } from 'zod';
import { IsoTimestamp } from './common';

export const ClaudeTokenScope = z.enum(['read-only', 'read-and-propose-fix']);
export type ClaudeTokenScope = z.infer<typeof ClaudeTokenScope>;

export const ClaudeTokenRow = z.object({
  jti: z.string(),
  actorEmail: z.string().email(),
  actorUserId: z.string(),
  scope: ClaudeTokenScope,
  intent: z.string().max(200),
  allowAutoMerge: z.boolean(),
  issuedAt: IsoTimestamp,
  expiresAt: IsoTimestamp,
  ttl: z.number().int(),
});
export type ClaudeTokenRow = z.infer<typeof ClaudeTokenRow>;

export const IssueClaudeTokenRequest = z.object({
  scope: ClaudeTokenScope,
  intent: z.string().min(1).max(200),
  allowAutoMerge: z.boolean().default(false),
});
export type IssueClaudeTokenRequest = z.infer<typeof IssueClaudeTokenRequest>;

export const IssueClaudeTokenResponse = z.object({
  token: z.string(),
  jti: z.string(),
  expiresAt: IsoTimestamp,
});
export type IssueClaudeTokenResponse = z.infer<typeof IssueClaudeTokenResponse>;
